import fetch from '../utils/fetch';

/**
 * APP-获取surpriseBoxActivity对象
 * https://apidoc.syounggroup.com/doc.html#/%E6%96%B0%E9%9B%B6%E5%94%AE/%E6%83%8A%E5%96%9C%E7%9B%92%E5%AD%90%E6%B4%BB%E5%8A%A8/getForAppUsingGET_1
 */
export function surpriseBoxActivityGetForApp(id) {
  return fetch.get(`/newretail/api/surpriseBoxActivity/getForApp?id=${id}`);
}

/**
 * APP-获取当前中奖跑马灯数据
 * https://apidoc.syounggroup.com/doc.html#/%E6%96%B0%E9%9B%B6%E5%94%AE/%E6%83%8A%E5%96%9C%E7%9B%92%E5%AD%90%E6%B4%BB%E5%8A%A8-%E6%8A%BD%E5%A5%96/listMemberLotteryPrizeUsingPOST
 */
export function surpriseBoxMemberLotteryListMemberLotteryPrize(params) {
  return fetch.post(`/newretail/api/surpriseBoxMemberLottery/listMemberLotteryPrize`, params);
}

/**
 * APP-创建抽奖付款交易记录
 * https://apidoc.syounggroup.com/doc.html#/%E6%96%B0%E9%9B%B6%E5%94%AE/%E6%83%8A%E5%96%9C%E7%9B%92%E5%AD%90%E6%B4%BB%E5%8A%A8-%E6%8A%BD%E5%A5%96/createTradeRecordUsingPOST
 */
export function surpriseBoxMemberLotteryCreateTradeRecord(params) {
  return fetch.post(`/newretail/api/surpriseBoxMemberLottery/createTradeRecord`, params);
}

/**
 * APP-取消抽奖付款交易记录
 * https://apidoc.syounggroup.com/doc.html#/%E6%96%B0%E9%9B%B6%E5%94%AE/%E6%83%8A%E5%96%9C%E7%9B%92%E5%AD%90%E6%B4%BB%E5%8A%A8-%E6%8A%BD%E5%A5%96/cancelTradeRecordUsingPOST
 */
export function surpriseBoxMemberLotteryCancelTradeRecord(params) {
  return fetch.post(`/newretail/api/surpriseBoxMemberLottery/cancelTradeRecord`, params);
}

/**
 * APP-抽奖-立即打开
 * https://apidoc.syounggroup.com/doc.html#/%E6%96%B0%E9%9B%B6%E5%94%AE/%E6%83%8A%E5%96%9C%E7%9B%92%E5%AD%90%E6%B4%BB%E5%8A%A8-%E6%8A%BD%E5%A5%96/drawUsingPOST
 */
export function surpriseBoxLotteryPrizeRecordDraw(params) {
  return fetch.post(`/newretail/api/surpriseBoxMemberLottery/draw`, params);
}

/**
 * APP-填写地址
 * https://apidoc.syounggroup.com/doc.html#/%E6%96%B0%E9%9B%B6%E5%94%AE/%E6%83%8A%E5%96%9C%E7%9B%92%E5%AD%90%E6%B4%BB%E5%8A%A8-%E6%8A%BD%E5%A5%96/writeMyAddressUsingPOST
 */
export function surpriseBoxMemberLotteryWriteMyAddress(params) {
  return fetch.post(`/newretail/api/surpriseBoxMemberLottery/writeMyAddress`, params);
}

/**
 * APP-获取用户参与活动情况
 * https://apidoc.syounggroup.com/doc.html#/%E6%96%B0%E9%9B%B6%E5%94%AE/%E6%83%8A%E5%96%9C%E7%9B%92%E5%AD%90%E6%B4%BB%E5%8A%A8-%E6%8A%BD%E5%A5%96/getMyLotteryInfoUsingGET
 */
export function surpriseBoxMemberLotteryGetMyLotteryInfo(activityId) {
  return fetch.get(
    `/newretail/api/surpriseBoxMemberLottery/getMyLotteryInfo?activityId=${activityId}`
  );
}

/**
 * APP-获取【我的奖品】分页列表
 * https://apidoc.syounggroup.com/doc.html#/%E6%96%B0%E9%9B%B6%E5%94%AE/%E6%83%8A%E5%96%9C%E7%9B%92%E5%AD%90%E6%B4%BB%E5%8A%A8-%E6%8A%BD%E5%A5%96/listPageMyPrizesUsingPOST
 */
export function surpriseBoxMemberLotteryListPageMyPrizes(params) {
  return fetch.post(`/newretail/api/surpriseBoxMemberLottery/listPageMyPrizes`, params);
}

/**
 * APP-获取【我的奖品】页面，查询用户还没有“抽奖-立即开启”的抽奖类型
 * https://apidoc.syounggroup.com/doc.html#/%E6%96%B0%E9%9B%B6%E5%94%AE/%E6%83%8A%E5%96%9C%E7%9B%92%E5%AD%90%E6%B4%BB%E5%8A%A8-%E6%8A%BD%E5%A5%96/listNotDrawOfMyPrizeUsingPOST
 */
export function surpriseBoxMemberLotteryListNotDrawOfMyPrize() {
  return fetch.post(`/newretail/api/surpriseBoxMemberLottery/listNotDrawOfMyPrize`);
}

/**
 * APP-用户是否参与过活动免费抽奖
 * https://apidoc.syounggroup.com/doc.html#/%E6%96%B0%E9%9B%B6%E5%94%AE/%E6%83%8A%E5%96%9C%E7%9B%92%E5%AD%90%E6%B4%BB%E5%8A%A8-%E6%8A%BD%E5%A5%96/izLotteryFreeUsingGET
 */
export function surpriseBoxMemberLotteryIzLotteryFree(activityId) {
  return fetch.get(
    `/newretail/api/surpriseBoxMemberLottery/izLotteryFree?activityId=${activityId}`
  );
}

/**
 * APP-获取用户中奖奖品（未填写地址的）
 * https://apidoc.syounggroup.com/doc.html#/%E6%96%B0%E9%9B%B6%E5%94%AE/%E6%83%8A%E5%96%9C%E7%9B%92%E5%AD%90%E6%B4%BB%E5%8A%A8-%E6%8A%BD%E5%A5%96/listMyDrawnPrizesUsingPOST
 */
export function surpriseBoxMemberLotteryListMyDrawnPrizes(params) {
  return fetch.post(`/newretail/api/surpriseBoxMemberLottery/listMyDrawnPrizes`, params);
}

/**
 * APP-报告分享，用户点击链接，完成分享
 * https://apidoc.syounggroup.com/doc.html#/%E6%96%B0%E9%9B%B6%E5%94%AE/%E6%83%8A%E5%96%9C%E7%9B%92%E5%AD%90%E6%B4%BB%E5%8A%A8-%E6%8A%BD%E5%A5%96/reportSharedUserUsingPOST
 */
export function surpriseBoxMemberLotteryReportSharedUser(params) {
  return fetch.post(`/newretail/api/surpriseBoxMemberLottery/reportSharedUser`, params);
}

/**
 * APP-获取用户当前免费抽奖次数
 * https://apidoc.syounggroup.com/doc.html#/%E6%96%B0%E9%9B%B6%E5%94%AE/%E6%83%8A%E5%96%9C%E7%9B%92%E5%AD%90%E6%B4%BB%E5%8A%A8-%E6%8A%BD%E5%A5%96/getFreeLotteryNumUsingGET
 */
export function surpriseBoxMemberLotteryGetFreeLotteryNum(activityId) {
  return fetch.get(
    `/newretail/api/surpriseBoxMemberLottery/getFreeLotteryNum?activityId=${activityId}`
  );
}

/**
 * APP-【我的奖品】获取用户指定活动未带走的免费奖品
 * https://apidoc.syounggroup.com/doc.html#/%E6%96%B0%E9%9B%B6%E5%94%AE/%E6%83%8A%E5%96%9C%E7%9B%92%E5%AD%90%E6%B4%BB%E5%8A%A8-%E6%8A%BD%E5%A5%96/listMyNotTakeFreePrizesUsingPOST
 */
export function surpriseBoxMemberLotteryLlistMyNotTakeFreePrizes(params) {
  return fetch.post(`/newretail/api/surpriseBoxMemberLottery/listMyNotTakeFreePrizes`, params);
}
